import template from './price-rent.jade';

import { getIncludedLocationIds as getUtilitiesTermsRequiredLocations } from '../utilities-terms/utilities-terms';
import { locationPathChanged } from '../../../../blocks/segments/address/address.events';

import { initializeSegmentInputTooltips } from '../../../utils/segment-input-tooltips';

export default angular
  .module('cian.addForm.priceRent', [])
  .directive('cianAfPriceAndDealTermsPriceRent', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller: function ($scope,
      categoryService,
      isSimpleFormEnabled,
      geoService,
      adTooltipsService,
      analyticsService,
      deviceService,
      popupService,
      excludeUtilitiesTermsRegionsService,
    ) {
      'ngInject';
      this.isUtilitiesTermsNotRequiredInRegion =
        excludeUtilitiesTermsRegionsService.isUtilitiesTermsNotRequiredInRegion();
      this.isMobile = deviceService.isMobile;
      this.tooltipText = '';
      this.ad.bargainTerms = this.ad.bargainTerms || {};


      this.openTooltipModal = () => {
        popupService.openPopup('hint', {
          text: this.tooltipText,
          title: 'Подсказка',
          hideCloseButton: false,
        });
      };

      const metersNotIncluded = {
        priceTitle: () => 'Арендная плата',
        showPeriod: false,
        caption: () => 'Без коммунальных услуг',
        showBargain: () => !isSimpleFormEnabled(),
        showVat: false,
      };

      const metersIncluded = {
        priceTitle: () => isSimpleFormEnabled() ? 'Арендная плата' : 'Цена в месяц',
        showPeriod: true,
        getPeriodText: () => {
          if (isSimpleFormEnabled()) {
            const locationPath = geoService.getLocationPath();
            const locationId = locationPath[locationPath.length - 1];
            const requiredLocations = getUtilitiesTermsRequiredLocations(this.isUtilitiesTermsNotRequiredInRegion)

            if (requiredLocations.includes(locationId)) {
              return 'в месяц, включая коммунальные платежи';
            }
          }

          return 'в месяц';
        },
        showBargain: () => !isSimpleFormEnabled(),
        showVat: false,
      };

      const config = {
        garage: {
          priceTitle: () => 'Цена за объект',
          showPeriod: false,
          getPeriodText: () => '',
          showBargain: () => false,
          showVat: false,
        },
        default: isUtilitiesTermsNotRequiredInRegion => {
          const fieldConfig = isUtilitiesTermsNotRequiredInRegion
            ? metersNotIncluded
            : metersIncluded;
          return fieldConfig;
        },
      };

      $scope.$watchGroup([
        () => this.ad.category,
        () => this.isUtilitiesTermsNotRequiredInRegion,
      ], ([category, isUtilitiesTermsNotRequiredInRegion]) => {
        if (!category) return;
        const { objectType } = categoryService.getInfoByCategory(category);
        this.config = config[objectType] || config.default(isUtilitiesTermsNotRequiredInRegion);

        if (objectType === 'garage') {
          this.ad.bargainTerms.paymentPeriod = 'monthly';
          this.ad.bargainTerms.priceType = 'all';
        }
      });

      const setRequireUtilitiesInRegionFlag = () => {
        this.isUtilitiesTermsNotRequiredInRegion = excludeUtilitiesTermsRegionsService.isUtilitiesTermsNotRequiredInRegion();
      };

      $scope.$on(locationPathChanged, setRequireUtilitiesInRegionFlag);

      this.modalHintTitle = 'Подсказка';

      initializeSegmentInputTooltips({
        controller: this,
        $scope,
        adTooltipsService,
        adAnalyticsCategory: analyticsService.adAnalyticsCategory,
        tooltipsKey: 'bargainTerms.price',
        trackingLabel: 'price-hint',
        popupService,
        isMobile: this.isMobile,
      });
    },

    controllerAs: 'priceRent',
    template,
  }))
  .name;
